.brandBackgroud {
  background-color: var(--bs-dark);
  border-bottom: 6px solid var(--bs-dark);
  border-bottom-right-radius: 32px;
  border-right: 1px solid var(--bs-dark);
  height: 70px;
  padding-left: 8px;
  position: absolute;
  top: 0;
  width: 240px;
  cursor: pointer;
}

.brandHolder {
  background-color: var(--bs-dark);
  height: 40px;
  margin-right: 0;
  position: relative;
  width: 230px;
}

.center {
  align-items: center;
  display: flex;
  flex-shrink: 1;
  justify-content: center;
  overflow: hidden;
  padding: 8px;
}

.endSection {
  background-color: inherit;
  color: none;
  height: 48px;
  min-height: 28px;
  position: relative;
  width: 244px;
}

.grid {
  display: grid;
  grid-template-columns: 240px calc(100% - 240px);
  grid-template-rows: 35px 35px;
  max-width: 100%;
  width: 100%;
}

.gridBrandCell {
  grid-row: 1 / span 2;
}

.gridRowOne {
  align-content: center;
  display: flex;
  flex-direction: row;
  grid-row: 1;
  justify-content: space-between;
}

.gridRowTwo {
  align-content: center;
  display: flex;
  flex-direction: row;
  gap: 0;
  grid-row: 2;
  justify-content: flex-start;
  max-width: calc(vw100 - 240px);
  padding-left: 16px;
  width: calc(vw100 - 240px);
}

.leftNav {
  max-width: 296px;
  min-width: 296px;
  width: 296px;
}

.menuHolder {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.rightNav {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  max-width: 300px;
}

.rightNavText {
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.titleText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
